<template>
  <div class="login-content">
    <div class="row g-0">
      <!-- Login Banner -->
      <login-banner></login-banner>
      <!-- /Login Banner -->

      <div class="col-12 col-lg-6 login-wrap-bg">
        <!-- Login -->
        <div class="login-wrapper">
          <div class="loginbox">
            <div class="w-100">
              <div
                class="d-flex align-items-center justify-content-between flex-wrap gap-2 login-header"
              >
                <img
                  src="@/assets/logo/sapta.png"
                  class="img-fluid login-brand-logo"
                  alt="Sapta LMS"
                />
                <router-link to="/home" class="link-1 text-nowrap"
                  >Back to Home</router-link
                >
              </div>
              <h1 class="fs-32 fw-bold topic">Sign into Your Account</h1>
              <Form
                ref="form"
                @submit="onSubmit"
                :validation-schema="schema"
                v-slot="{ errors }"
                class="mb-3 pb-3"
              >
                <div class="mb-3 position-relative">
                  <label class="form-label" for="login-name"
                    >Name<span class="text-danger ms-1">*</span></label
                  >
                  <Field
                    id="login-name"
                    name="name"
                    type="text"
                    v-model="name"
                    class="form-control"
                    :class="{ 'is-invalid': errors.name }"
                    autocomplete="username"
                    autocapitalize="none"
                    spellcheck="false"
                  />
                  <div class="invalid-feedback">{{ errors.name }}</div>
                </div>
                <div class="mb-3 position-relative">
                  <label class="form-label" for="login-password"
                    >Password <span class="text-danger">*</span></label
                  >
                  <div class="position-relative">
                    <Field
                      id="login-password"
                      name="password"
                      :type="showPassword ? 'text' : 'password'"
                      v-model="password"
                      class="pass-inputa form-control"
                      :class="{ 'is-invalid': errors.password }"
                      autocomplete="current-password"
                    />
                    <button
                      v-if="!errors.password"
                      type="button"
                      class="btn btn-link p-0 border-0 toggle-passworda text-gray-7 fs-14"
                      :class="showPassword ? 'isax isax-eye' : 'isax isax-eye-slash'"
                      :aria-label="
                        showPassword ? 'Hide password' : 'Show password'
                      "
                      :aria-pressed="showPassword"
                      @click="toggleShow"
                    ></button>
                    <div class="invalid-feedback">{{ errors.password }}</div>
                  </div>
                </div>
                <div class="d-grid">
                  <button class="btn btn-secondary btn-lg" type="submit">
                    Login
                    <i class="isax isax-arrow-right-3 ms-1" aria-hidden="true"></i>
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <BaseLoading :dialog="true" v-if="sharedStore.loading"></BaseLoading>
</template>

<script>
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import { useAuthStore } from "@/stores/auth-store";
import { useSharedStore } from "@/stores/shared-store";
import BaseLoading from "@/components/CustomComponent/shared/Loading.vue";

export default {
  components: {
    Form,
    Field,
    BaseLoading,
  },
  data() {
    return {
      name: null,
      showPassword: false,
      password: null,
      nameError: "",
      passwordError: "",
      schema: Yup.object({
        name: Yup.string().required("Nama wajib diisi"),
        password: Yup.string().required("Password wajib diisi"),
      }),
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    async onSubmit() {
      const result = await this.$refs.form.validate();
      if (!result.valid) return;

      await useAuthStore().login(this.name, this.password);
    },
  },
  setup() {
    const sharedStore = useSharedStore();
    return {
      sharedStore,
    };
  },
};
</script>
